import { render, staticRenderFns } from "./Package_Add_Service.vue?vue&type=template&id=1cd896b6&scoped=true&"
import script from "./Package_Add_Service.vue?vue&type=script&lang=js&"
export * from "./Package_Add_Service.vue?vue&type=script&lang=js&"
import style0 from "./Package_Add_Service.vue?vue&type=style&index=0&id=1cd896b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd896b6",
  null
  
)

export default component.exports